<template>
  <div 
    v-if="aids.length > 1"
    class="ProductStateAid ProductShipping-cardsRowSmall"
  >

    <div class="ProductStateAid-row">
      <p class="ProductStateAid-title"><span>Aides de l'état</span> {{ new Date().getFullYear() }}</p>
    
    <div class="ProductStateAid-discount">
        <ProductPriceRecap
          :originalPrice="-totalAmountDiscount"
        ></ProductPriceRecap>
      </div>
    </div>

    <div
    v-if="this.productOptions.government_aids.infos.description || this.productOptions.government_aids.infos.small_text"
      class="ProductStateAid-seeMore"
      :class="showDetailsAids ? 'open' : ''"
      @click="toggleOpen"
    >
      <div>
        <span v-if="showDetailsAids">Masquer</span>
        <span v-else>Afficher</span>
        <span v-if="this.isPacHybride">les aides</span>
      </div>
    </div>
    
    
    <!-- AIDS DETAILS  -->
    <div
      v-if="showDetailsAids"
    >
      <!-- PAC HYBRIDE - SHOW AIDS DETAILS -->
      <div v-if="this.isPacHybride">
          <div
            class="ProductStateAid-row ProductStateAid-details"
            v-for="(aid, index) in aids"
            :key="index"
          >
          
            <p v-if="aid.discount_amount">
              {{ aid.name }}
              <ToolTip v-if="aid.description" :text="aid.description" :classProps="'left'"></ToolTip>
            </p>

            <div v-if="aid.discount_amount" class="ProductStateAid-discount">
            
              <span>jusqu'à </span>

              <ProductPriceRecap
                :originalPrice="aid.discount_amount"
              ></ProductPriceRecap>
            </div>
          </div>
          

          <p class="eligibility-conditions">
            *Soumis aux conditions d'éligibilités de revenus. La prime CEE est déduite directement du devis. Pour la prime Rénov, nous vous accompagnons pour le dépôt de son obtention, elle vous sera versée directement après les travaux.
          </p>
      </div>


      <!-- OTHER PAC - SHOW TEXT -->
      <div v-else>
        <div class="ProductStateAid-row ProductStateAid-details">
          <p v-if="this.productOptions.government_aids.infos.description" style="margin: 15px 0;">
            {{ this.productOptions.government_aids.infos.description }}
          </p>
        </div>

        <p v-if="this.productOptions.government_aids.infos.small_text" class="eligibility-conditions">
          {{ this.productOptions.government_aids.infos.small_text }}
        </p>
    </div>
    </div>
  </div>
</template>

<script>
import ProductPriceRecap from "@/includes/Product/ProductPrice/ProductPriceRecap.vue";
import ToolTip from "@/components/ToolTip/ToolTip.vue";
import { mapGetters } from "vuex";

import "./ProductStateAid.scss";


export default {
  name: "ProductStateAid",

  components: {
    ProductPriceRecap,
    ToolTip,
  },

  data() {
    return {
      aids: [],
      totalAidsDiscount: {},
      showDetailsAids : false,
      totalAmountDiscount: 0,
      isPacHybride: false,
    };
  },

  props: {
    discountDetails: {
      type: Object,
      required: false,
      default: [],
    },
  },

  computed: {
    ...mapGetters({
      productOptions: "getProductOptions",
      productCurrentTva: "getProductTVAForCurrentDelivery",
      preprendCartCurrentSelectedDelivery: "getPreprendCartCurrentSelectedDelivery",
      productShippingList: "getProductShippingMethods",
      currentTva: "getProductTVAForCurrentDelivery",
      pacType: "getPacType",
    }), 
  },

  methods: {
    getTotalDiscount () {
      if(this.productShippingList[this.preprendCartCurrentSelectedDelivery] && this.productShippingList[this.preprendCartCurrentSelectedDelivery].total_price.available_government_aids) {
        this.totalAidsDiscount = this.productShippingList[this.preprendCartCurrentSelectedDelivery].total_price.available_government_aids
      }
    },

    getTotalAmountDiscount (aids) {
      aids.forEach(aid => {
        this.totalAmountDiscount += aid.discount_amount;
      });
    },

    toggleOpen() {
      this.showDetailsAids = !this.showDetailsAids
    }
  },

  mounted() {
    
    if(this.pacType && this.pacType === 'Pompe à chaleur hybride') {
      this.isPacHybride = true;
    }
    if(this.discountDetails && this.discountDetails.length > 0) {
      this.discountDetails.forEach(discount => {
        if(discount.couponType !== "2") {
          this.aids.push(discount)
        }
      })
      this.getTotalAmountDiscount(this.aids)
    } else {
      this.getTotalDiscount()

      if(this.totalAidsDiscount[this.currentTva]) {
        this.totalAmountDiscount = this.totalAidsDiscount[this.currentTva].amount;
        this.aids = Object.values(this.totalAidsDiscount[this.currentTva].details);
      }
    }
  },
  
};
</script>
